// @flow
import React, { Component } from 'react';
import {
  CryptoBadgeItemTitleDiv,
  CryptoBadgeDownloadLinkA,
  BorderDiv,
  CryptoBadgeDownloadItem,
  DownloadImageLinkA
} from './MarketingCollateralStyles';
import cryptoBadgeImg from '../../assets/images/pay-w-btc-eth-ltc-bch-xrp-more.png';
import { type MarketingFile } from './index';
import CollateralItem from './CollateralItem';

type Props = {
  marketingFiles: MarketingFile[],
  marketingCollateral: MarketingFile[]
};

export default class MarketingCollateral extends Component<Props> {
  render() {
    return (
      <div>
        {this.props.marketingFiles.slice(0, 1).map(file => (
          <CryptoBadgeDownloadItem key={file.name}>
            <CryptoBadgeItemTitleDiv>
              <h3>{file.name}</h3>
              <BorderDiv />
              <CryptoBadgeDownloadLinkA
                href={file.url}
                target="_blank"
                download={`NetCents ${file.name}`}
              >
                Download {`${file.file_type}`}
              </CryptoBadgeDownloadLinkA>
            </CryptoBadgeItemTitleDiv>
            {file.description && <p>{file.description}</p>}
            <DownloadImageLinkA
              href={file.url}
              target="_blank"
              download={`NetCents ${file.name}`}
            >
              <img src={cryptoBadgeImg} alt="" />
            </DownloadImageLinkA>
          </CryptoBadgeDownloadItem>
        ))}
        <CollateralItem
          label="Window Decal"
          description="Want to show that you are accepting cryptocurrency payments in-store? Email our merchant support team to request our merchant in-store window storefront sticker decals."
          href="mailto:merchantsupport@net-cents.com?subject=Merchant Gateway Window Decal"
          linkText="merchantsupport@net-cents.com"
        />
        {this.props.marketingCollateral.map(file => (
          <CollateralItem
            key={file.name}
            label={file.name}
            description={file.description}
            href={file.url}
            linkText={`Download ${file.name}`}
          />
        ))}
      </div>
    );
  }
}
